import type { CustomFormErrors, FormErrors } from 'redux-form';

export class MaterialGroupFM_single {
	name: string;

	constructor() {
		this.name = '';
	}

	static validate = (form: MaterialGroupFM_single, existingNamesCount: Record<string, number>) => {
		const errors: FormErrors<MaterialGroupFM_single> = {};

		if (!form.name) {
			errors.name = 'The Group name is required.';
		} else if (existingNamesCount[form.name.toUpperCase()] > 1) {
			errors.name = 'A group with this name already exists.';
		}

		return errors;
	};
}

class MaterialGroupFM {
	groups: MaterialGroupFM_single[];
	existingNames: string[];

	constructor() {
		this.groups = [];
		this.existingNames = [];
	}

	static validate = (form: MaterialGroupFM): CustomFormErrors<MaterialGroupFM> => {
		const errors: CustomFormErrors<MaterialGroupFM> = {};
		if (!form.groups) {
			return {};
		}

		const existingNamesCount = [
			...(form.existingNames ?? []),
			...form.groups.map((_group) => _group.name?.toUpperCase()),
		].reduce<Record<string, number>>((_acc, _name) => {
			if (!(_name in _acc)) {
				_acc[_name] = 1;
			} else {
				_acc[_name] += 1;
			}
			return _acc;
		}, {});

		for (const group of form.groups) {
			if (!errors.groups) {
				errors.groups = [];
			}
			(errors.groups as FormErrors<MaterialGroupFM_single>[]).push(MaterialGroupFM_single.validate(group, existingNamesCount));
		}

		return errors as FormErrors<MaterialGroupFM>;
	};
}

export default MaterialGroupFM;
